import React, { useContext } from "react";
import Carousel from 'react-bootstrap/Carousel'
import { useSelector } from 'react-redux';
import { Col, Row, Container } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTv, faPhone, faMusic, faWheelchair, faKey, faFan, faTemperatureHigh, faClock, faVoicemail, faCheckCircle, faCheck, faRoute, faDirections } from '@fortawesome/free-solid-svg-icons';
import { getCDNImage } from '../globals';
import TitleBar from '../components/TitleBar';
import { i18nValue } from '../functions';
import { T } from "react-translator-component";
import Screen from '../components/Screen';
import { HotelContext } from '../context/hotel'
import { UserContext } from "../context/user";
import { isHostzSwissstay } from "../components/CheckIn/hotelConditions";
import { CheckInContext } from "../context/checkin";

const Location = ({ navigation, route, section = 'all' }) => {

  const { data: hotel, placeholders, languages } = useContext(HotelContext)
  const { address, amenities, covid, gallery, email, location, name, phone, web } = hotel;
  const { data: checkIn } = useContext(CheckInContext);
  const { Room, language, RoomCategory } = useContext(UserContext);

  // const hotelData = useSelector((state) => state?.hotelReducer);
  // const { language } = hotelData;
  // const { address, amenities, covid, gallery, email, location, name, phone, web } = hotelData.data;
  // const { title, titleI18n, desc, descI18n } = hotelData.sections.info;
  // const { info: data } = hotelData.sections;


  // if (!location) return <p>Loading...</p>;
  const hotelAddress = () => {
    let textValue = address ?? '--';

    const _placeholders = { ...placeholders, ...checkIn?.placeholders };

    if (_placeholders) {

      if (isHostzSwissstay(hotel.id)) {
        const ph_key = RoomCategory?.code
        let _default_lang = languages?.[0];
        if (_default_lang) {
          _default_lang = _default_lang.toLowerCase();
          if (_default_lang === "en" || _default_lang === "us") {
            _default_lang = "en-US"
          }
        }
        // let placeholderValue = _placeholders?.["UNITGROUP-ADDRESS"]?.[ph_key];
        let placeholderValue = _placeholders?.["UNITGROUP-ADDRESS"];
        if (placeholderValue) {
          if (typeof placeholderValue !== "string") {
            textValue = placeholderValue?.[language] || placeholderValue?.[_default_lang];
          }
        }
      }
    }
    return textValue;
  }

  const getHotelLocation = () => {

    let locationValue = location;

    const _placeholders = { ...placeholders, ...checkIn?.placeholders };

    if (_placeholders) {
      if (isHostzSwissstay(hotel.id)) {
        const ph_key = RoomCategory?.code
        let _default_lang = languages?.[0];
        if (_default_lang) {
          _default_lang = _default_lang.toLowerCase();
          if (_default_lang === "en" || _default_lang === "us") {
            _default_lang = "en-US"
          }
        }

        // let placeholderValue = placeholders?.["UNITGROUP-GEOLOCATION"]?.[ph_key];
        let placeholderValue = _placeholders?.["UNITGROUP-GEOLOCATION"];
        if (placeholderValue) {
          if (typeof placeholderValue !== "string") {
            let placeholderValueLang = placeholderValue?.[language] || placeholderValue?.[_default_lang];
            let aux = placeholderValueLang.split(',')
            if (aux.length > 1) {
              locationValue = { 'lat': aux[0], 'lng': aux[1] }
            }
          }
        }
      }
    }
    return locationValue;
  }
  const hotelLocation = getHotelLocation()

  let locationSrc = null;
  if (hotelLocation?.lat && hotelLocation?.lng) {
    locationSrc = `https://maps.google.com/maps?q=loc:${hotelLocation.lat},${hotelLocation.lng}&z=12&output=embed&`;
  }
  return (
    <Screen
      section="lo"
    >
      <iframe frameborder="0" style={{ position: "fixed", top: 60, left: 0, right: 0, bottom: 0, border: "0", width: "100%", height: "90vh" }} src={locationSrc} allowfullscreen=""></iframe>
      <div className="card-generic p-3" style={{ position: "fixed", top: 70, left: 10, right: 60, borderRadius: 0, boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.8)" }}>
        <Row className="page-subheader">
          <Col>
            <p className="font-sm mb-2 mt-0">{T("maps.how_to_reach_us")}</p>
            <p className="mb-0 font-md"><b dangerouslySetInnerHTML={{ __html: hotelAddress() }}></b></p>
            <p className="mb-0 font-md my-2"><a href={"tel:" + phone}>{phone}</a></p>
            <a
              href={hotelLocation?.lat && hotelLocation?.lng && `https://maps.google.com/maps/dir/${hotelLocation?.lat},${hotelLocation?.lng}/@${hotelLocation?.lat},${hotelLocation?.lng}`}
              target="_blank"
              className="btn btn-info"
            ><FontAwesomeIcon icon={faDirections} color="#FFF" style={{ fontSize: 14 }} className="mr-2" /> {T("maps.get_directions")}</a>
          </Col>
        </Row>
      </div>
    </Screen>
  );
}

export default Location;